/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

if($('.section-left-right-image').length) {
  $(window).scroll(function() {
     var hTD = $('.section-left-right-image').offset().top,
         hTU = $('.section-left-right-image').offset().top + $('.section-left-right-image').outerHeight() / 2,
         hHD = $('.section-left-right-image').outerHeight() / 2,
         hHU = $('.section-left-right-image').outerHeight(),
         wH = $(window).height(),
         wS = $(this).scrollTop();
     if ((wS > (hTD+hHD-wH) && (hTD > wS) && (wS+wH > hTD+hHD)) || wS > (hTU+hHU-wH) && (hTU > wS) && (wS+wH > hTU+hHU)){
       $('.section-left-right-image').addClass('animate-ba');
     }
  });
}

if($('.c-animate').length) {
  $('.c-animate').each(function(index){
    $(window).scroll(function() {
      if($('.c-animate-a'+index).offset()) {
        var hTD = $('.c-animate-a'+index).offset().top,
            hTU = $('.c-animate-a'+index).offset().top + $('.c-animate-a'+index).outerHeight() / 2,
            hHD = $('.c-animate-a'+index).outerHeight() / 2,
            hHU = $('.c-animate-a'+index).outerHeight(),
            wH = $(window).height(),
            wS = $(this).scrollTop();
        if ((wS > (hTD+hHD-wH) && (hTD > wS) && (wS+wH > hTD+hHD)) || wS > (hTU+hHU-wH) && (hTU > wS) && (wS+wH > hTU+hHU)){
          $('.c-animate-a'+index).addClass('animate__animated').addClass($('.c-animate-a'+index).data('animate'));
          if ($(window).width() > 991) {
            $('.c-animate-b'+index).addClass('animate__animated').addClass($('.c-animate-b'+index).data('animate'));
          }
        }
      }

      if ($(window).width() < 992) {
        if($('.c-animate-a'+index).offset()) {
          var hTD = $('.c-animate-b'+index).offset().top,
              hTU = $('.c-animate-b'+index).offset().top + $('.c-animate-b'+index).outerHeight() / 2,
              hHD = $('.c-animate-b'+index).outerHeight() / 2,
              hHU = $('.c-animate-b'+index).outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();
          if ((wS > (hTD+hHD-wH) && (hTD > wS) && (wS+wH > hTD+hHD)) || wS > (hTU+hHU-wH) && (hTU > wS) && (wS+wH > hTU+hHU)){
            $('.c-animate-b'+index).addClass('animate__animated').addClass($('.c-animate-b'+index).data('animate'));
          }
        }
      }
    });
  });
}

if($('.filter-tags').length) {
  tag_list = Object.keys(tag_list).sort().reduce(
    (obj, key) => { 
      obj[key] = tag_list[key]; 
      return obj;
    }, 
    {}
  );

  $.each(tag_list, function(key, value) {
    $("#c-filter-content").append('<a href="#" data-filter="'+key+'">'+value+'</a>');
  });

  var hash = window.location.hash;
  if(hash) {
    var tag = hash.substring(1);
    $('.collection-filter .dropbtn').text(tag.replace(/\-/g, ' '));
  	filterProjects(tag);
  }
  
  $('.filter-tags a').click(function(e) {
    e.preventDefault();
    var tag = this.dataset.filter;
    $('.collection-filter .dropbtn').text($(this).text());
    filterProjects(tag);
  });
  
  function filterProjects(tag) {
    if(tag == 'show-all') {
      $('.CollectionItem').removeClass('CollectionItem-hidden');
    } else {
      $('.CollectionItem').addClass('CollectionItem-hidden');
      $('.CollectionItem__Wrapper.'+tag).parent().parent().removeClass('CollectionItem-hidden');
    }
  }

  function filterMenu() {
    document.getElementById("c-filter-content").classList.toggle("show");
  }

  window.onclick = function(event) {
    if (!event.target.matches('.dropbtn')) {
      var dropdowns = document.getElementsByClassName("c-filter-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  }
}

if($('a.see-more').length) {
  $('a.see-more').on('click', function(e){
    e.preventDefault();
    $(this).parent().removeClass('list-expandable');
    $(this).hide();
    $(this).parent().find('.see-less').show();
  });
  $('a.see-less').on('click', function(e){
    e.preventDefault();
    $(this).parent().addClass('list-expandable');
    $(this).hide();
    $(this).parent().find('a.see-more').show();
  });
}

if ($(window).width() < 992) {
  $('.Form__Select option').each(function() {
     var thisAttr = $(this).attr('disabled');
     if(thisAttr == "disabled") {
        $(this).remove();
     }
  });
}